module.exports = "/_next/static/images/85ec233d35bdf2471eb3a9dad7891d53-cards-left-large.jpg.webp";